const GetCatchRanking = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/Ranking?includeCensored=true`);
        if (!response.ok) return { success: false, data: [] };
        const data = await response.json();
        return { success: true, data };
    } catch {
        return { success: false, data: [] };
    }
};

const EditCatchPlayer = async (id, nickname, isCensored) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/EditPlayer`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, nickname, isCensored })
        });
        return { success: response.ok };
    } catch {
        return { success: false };
    }
};

// const SendCatchScreenCommand = async (commandStr, payloadObj = null) => {
//     try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/ScreenControl`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ command: commandStr, payload: payloadObj })
//         });
//         return { success: response.ok };
//     } catch {
//         return { success: false };
//     }
// };

const SendCatchScreenCommand = async (commandStr, payloadObj = null) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/ScreenControl`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            // Enviamos el 'command' y el 'payload' para que C# los atrape
            body: JSON.stringify({ command: commandStr, payload: payloadObj }) 
        });
        return { success: response.ok };
    } catch {
        return { success: false };
    }
};

const SendCatchAdminControl = async (actionStr, durationValue = null) => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/AdminControl`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: actionStr, duration: durationValue })
        });
    } catch {}
};

const GetAllCatchPlayers = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/AllPlayers`);
        return { success: response.ok, data: response.ok ? await response.json() : [] };
    } catch { return { success: false, data: [] }; }
};

const ResetAllCatchScores = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/ResetAll`, { method: 'DELETE' });
        return { success: response.ok };
    } catch { return { success: false }; }
};

const SubmitManualCatchScore = async (userData) => {
    try {
        // Reciclamos el endpoint original de guardar score
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/SubmitScore`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userData)
        });
        return { success: response.ok };
    } catch { return { success: false }; }
};

const GiveSecondChance = async (userData) => {
    try {
        // Disparamos un JOIN fantasma para que la pantalla empiece a jugar
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/Join`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userData)
        });
        return { success: response.ok };
    } catch { return { success: false }; }
};

export { GetCatchRanking, EditCatchPlayer, SendCatchScreenCommand, SendCatchAdminControl, GetAllCatchPlayers, ResetAllCatchScores, SubmitManualCatchScore, GiveSecondChance };